import React from 'react';

const SvgSort = (props) => (
  <svg width={6} height={10} {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M0 6h5.455L2.727 9.636zM0 3.636h5.455L2.727 0z" />
    </g>
  </svg>
);

export default SvgSort;
